import { render, staticRenderFns } from "./CoursewareAccordionContainer.vue?vue&type=template&id=56498bf0&"
import script from "./CoursewareAccordionContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareAccordionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56498bf0')) {
      api.createRecord('56498bf0', component.options)
    } else {
      api.reload('56498bf0', component.options)
    }
    module.hot.accept("./CoursewareAccordionContainer.vue?vue&type=template&id=56498bf0&", function () {
      api.rerender('56498bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareAccordionContainer.vue"
export default component.exports